import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IHttpApi } from '@cian/http-api';

export interface IError {
  code: string;
  key: string;
  message: string;
}

export const defaultConfig: TRegisterEndpointModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'webPushNotifications',
  pathApi: '/subscribe/',
};

export function createRegisterEndpointModel(config: Partial<TRegisterEndpointModel>): TRegisterEndpointModel {
  return { ...defaultConfig, ...config };
}

export interface IRegisterEndpointRequestScheme {
  subscription: PushSubscription;
  fromPopup?: boolean;
  webTimezone: string;
}

export type TRegisterEndpointModel = IModel<IRegisterEndpointRequestScheme, TRegisterEndpointResponseScheme>;

export type TRegisterEndpointResponseScheme = IRegisterEndpointResponse200 | IRegisterEndpointResponse400;

export interface IRegisterEndpointResponse200 extends IModelResponse<IRegisterEndpointResponseScheme> {
  statusCode: 200;
}

export interface IRegisterEndpointResponseScheme {
  userId: string;
}

export interface IRegisterEndpointResponse400 extends IModelResponse<IRegisterEndpointErrorResponseScheme> {
  statusCode: 400;
}

export interface IRegisterEndpointErrorResponseScheme {
  errors: IError[];
  message: string;
}

export function registerEndpointRequest(
  httpApi: IHttpApi,
  subscription: PushSubscription,
  fromPopup: boolean = false,
): Promise<TRegisterEndpointResponseScheme> {
  const webTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return httpApi.fetch(
    createRegisterEndpointModel({ parameters: { subscription, fromPopup, webTimezone } }),
    undefined,
  );
}
